import { Button, Card, CardButtonActionMode, HeaderGradient, MiniCard, Row } from '@app/components';
import React, { memo } from 'react';
import { theme } from '@app/theme';
import { useDynamicSizes } from '@app/hooks';
import LinearGradient from 'react-native-linear-gradient';
import { StyleSheet } from 'react-native';
import { ICatalogSnapshot } from '@app/common';
import { triptychSelectors } from '@app/store';
import { useAppSelector } from '@app/store/hooks';

type CatalogSnapshotCardProps = {
  catalogSnapshot?: Partial<ICatalogSnapshot>;
  toggle: (mode: CardButtonActionMode) => void;
};

export const CatalogSnapshotCard = memo(({ toggle, catalogSnapshot }: CatalogSnapshotCardProps) => {
  const { subContainerHeight } = useDynamicSizes();

  const isOpen = useAppSelector(triptychSelectors.selectIsOpen);

  return (
    <Card>

      <HeaderGradient>
        <LinearGradient
          start={{ x: 0.5, y: 0 }}
          end={{ x: 0.5, y: 1 }}
          locations={[0, 1]}
          colors={['rgba(253, 255, 252, 0)', 'rgba(253, 255, 252, 1)']}
          style={styles.headerGradient}
        />
      </HeaderGradient>

      <Card.TopHeader>
        <Card.TopHeaderLabel>Fiche catalogue</Card.TopHeaderLabel>
      </Card.TopHeader>

      <Card.Container height={subContainerHeight}>
        <Card.Background source={require('@app/assets/img/cardbackground.png')} />

        <Card.Content>
          <Card.Header>
            <Row justify="space-between" align="center">
              <Card.HeaderTitles>
                <Card.Title numberOfLines={2}>{catalogSnapshot?.name}</Card.Title>
              </Card.HeaderTitles>

              {isOpen && (
                <Button
                  title="Fermer"
                  bordered
                  onPress={() => toggle("CLOSE")} />
              )}
            </Row>
          </Card.Header>
        </Card.Content>

        <MiniCard>
          <MiniCard.Container />
        </MiniCard>
      </Card.Container>
    </Card>
  );
});


const styles = StyleSheet.create({
  headerGradient: {
    flex: 1,
    height: theme.sizes.listHeaderHeight,
  },
});
